const Clips = ({video})=>{ 
return (<>
    <li className="relative w-10 rounded-lg h-10 md:h-16 md:w-16 overflow-hidden justify-start cursor-pointer">
        <i className="playBTN fas fa-play-circle"></i>
        <img className="h-full object-cover" src={video?.imgsrc} alt={video?.imgsrc}/>
        <video className="absolute w-full h-full " src={video?.clip} loop></video>
    </li>
</>)
}
export default Clips